<div class="admin-layout">
  <!-- Header -->
  <app-header-admin></app-header-admin>

  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
